module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/icon_Blue_Exclusive-7bf9b2cbb75d865409041844e41eeb26.png";